import React from 'react';
import { ShoppingCart, GraduationCap, Stethoscope, Building2, ArrowRight } from 'lucide-react';
import { SEGMENTS } from '../mock';

const iconMap = { ShoppingCart, GraduationCap, Stethoscope, Building2 };

const Segments = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#FAF6F2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1fr_1.5fr] gap-10 lg:items-start">
          <div className="lg:sticky lg:top-24">
            <div className="text-[11px] font-bold uppercase tracking-widest text-[#FF5B24]">SEU SEGMENTO</div>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a0e27] leading-tight">
              Funciona no seu segmento. <span className="text-[#FF5B24]">Veja como.</span>
            </h2>
            <p className="mt-4 text-slate-600">
              Veja como empresas do seu segmento estão transformando o atendimento com a CoreDesk.
            </p>
          </div>

          <div className="space-y-4">
            {SEGMENTS.map((s) => {
              const Icon = iconMap[s.icon];
              return (
                <div
                  key={s.title}
                  className="group bg-white rounded-2xl p-6 border border-slate-100 hover:border-[#FF5B24]/40 hover:shadow-xl transition-all cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-[#FFF1EA] flex items-center justify-center group-hover:bg-[#FF5B24] transition-colors shrink-0">
                      <Icon size={22} className="text-[#FF5B24] group-hover:text-white transition-colors" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-extrabold text-xl text-[#0a0e27]">{s.title}</h3>
                      <p className="mt-1 text-sm font-semibold text-slate-700">{s.lead}</p>
                      <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.body}</p>
                      <div className="mt-3 flex items-center gap-2 text-xs font-semibold text-[#FF5B24]">
                        <span>{s.highlight}</span>
                        <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Segments;
